/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayModelLightResponse } from './DayModelLightResponse';
import {
    DayModelLightResponseFromJSON,
    DayModelLightResponseFromJSONTyped,
    DayModelLightResponseToJSON,
    DayModelLightResponseToJSONTyped,
} from './DayModelLightResponse';

/**
 * Response for week model
 * @export
 * @interface WeekModelResponse
 */
export interface WeekModelResponse {
    /**
     * Unique identifier of the week model
     * @type {string}
     * @memberof WeekModelResponse
     */
    weekModelId?: string;
    /**
     * Name of week model
     * @type {string}
     * @memberof WeekModelResponse
     */
    name?: string;
    /**
     * Name of week of day
     * @type {string}
     * @memberof WeekModelResponse
     */
    weekday?: string;
    /**
     * 
     * @type {DayModelLightResponse}
     * @memberof WeekModelResponse
     */
    dayModel?: DayModelLightResponse;
}

/**
 * Check if a given object implements the WeekModelResponse interface.
 */
export function instanceOfWeekModelResponse(value: object): value is WeekModelResponse {
    return true;
}

export function WeekModelResponseFromJSON(json: any): WeekModelResponse {
    return WeekModelResponseFromJSONTyped(json, false);
}

export function WeekModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeekModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'weekModelId': json['weekModelId'] == null ? undefined : json['weekModelId'],
        'name': json['name'] == null ? undefined : json['name'],
        'weekday': json['weekday'] == null ? undefined : json['weekday'],
        'dayModel': json['dayModel'] == null ? undefined : DayModelLightResponseFromJSON(json['dayModel']),
    };
}

export function WeekModelResponseToJSON(json: any): WeekModelResponse {
    return WeekModelResponseToJSONTyped(json, false);
}

export function WeekModelResponseToJSONTyped(value?: WeekModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekModelId': value['weekModelId'],
        'name': value['name'],
        'weekday': value['weekday'],
        'dayModel': DayModelLightResponseToJSON(value['dayModel']),
    };
}

